// ISO-2 → display name. Mirror of `git/code/neo4j_loader/country_map.py`.
// Keep both in sync; v1 duplicates rather than generates a shared JSON.
const COUNTRY_NAMES: Record<string, string> = {
  AE: 'United Arab Emirates',
  AT: 'Austria',
  BR: 'Brazil',
  BY: 'Belarus',
  CN: 'China',
  DE: 'Germany',
  DZ: 'Algeria',
  EG: 'Egypt',
  ES: 'Spain',
  FR: 'France',
  GB: 'United Kingdom',
  ID: 'Indonesia',
  IL: 'Israel',
  IN: 'India',
  IQ: 'Iraq',
  IR: 'Iran',
  IT: 'Italy',
  KE: 'Kenya',
  KP: 'North Korea',
  KR: 'South Korea',
  KZ: 'Kazakhstan',
  LB: 'Lebanon',
  LY: 'Libya',
  MA: 'Morocco',
  MY: 'Malaysia',
  NG: 'Nigeria',
  PK: 'Pakistan',
  PS: 'Palestine',
  RO: 'Romania',
  RU: 'Russia',
  SY: 'Syria',
  TN: 'Tunisia',
  TR: 'Türkiye',
  TW: 'Taiwan',
  UA: 'Ukraine',
  US: 'United States',
  VN: 'Vietnam',
};

function normalize(value: string | null | undefined): string | null {
  if (!value) return null;
  const trimmed = value.trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(trimmed)) return null;
  return trimmed;
}

export function countryFlag(value: string | null | undefined): string | null {
  const cc = normalize(value);
  if (!cc) return null;
  const codePoints = [...cc].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65);
  return String.fromCodePoint(...codePoints);
}

export function countryLabel(value: string | null | undefined): string | null {
  const cc = normalize(value);
  if (!cc) return null;
  return COUNTRY_NAMES[cc] ?? cc;
}
